'use client'
import { type FC } from 'react'
import { HelpCenter } from './HelpCenter'
import { useToggles } from '@/tools/toggles/client'

// Can remove this wrapper when toggle deleted https://glovoapp.atlassian.net/browse/WEBX-714
export const HelpCenterWrapper: FC = () => {
  const { toggles } = useToggles()
  const isHelpCenterRendered =
    toggles.WEBX_REACT_DH_HELP_CENTER_ENABLED && toggles.CUSTOMER_HELP_CENTER_ENABLED

  return <>{isHelpCenterRendered && <HelpCenter />}</>
}
